<!--
 * @Date: 2022-3-8 11:09:20
 * @Author: WZ
 * @Description:
-->
<template>
  <div>
    <el-dialog lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :title="$lang('提醒')"
      :visible="superVisible"
      @close="hideDiaLog"
      width="45%"
      class="super-dialog">
      <div class="text">{{$lang('目的区域未覆盖或不安全，可能会产生额外的费用')}}</div>
      <div class="dialog-footer">
        <el-button type="primary"  @click="hideDiaLog" size="big">{{$lang('确定')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SuperZone',
  data() {
    return {
      superVisible: this.dialogVisible, // 是否弹出
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialogVisible: {
      handler(val) {
        this.superVisible = val
      },
      immediate: true,
    },
  },
  methods: {
    hideDiaLog() {
      this.$emit('update:dialogVisible', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.super-dialog{
  ::v-deep .el-dialog__header {
    border-bottom: 0;
  }
  .text {
    font-size: 16px;
    color: #3c3c3c;
    text-align: center;
    word-break: break-word;
  }
  .dialog-footer {
    border-top: 0;
  }
}
</style>
